//Text setting Format
import { rules } from '@/plugins/custom.js'
export var textSF = {
    type: "text",
    cmpName: "VText",
    icon: "mdi-cursor-text",
    label: "Tek Satırlı Metin",

    required: false,
    placeholder: "Yanıtınız",
    counter: 20,
    color: null,
    disable: false,
    hint: "",
    prefix: "",
    suffix: "",
    rules: [],
    identity: false,
    cols: 12,
    grpName:"",
    mask:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir
}
export var textMatrixSF = {
    type: "textMatrix",
    cmpName: "VTextMatrix",
    icon: " mdi-view-list-outline",
    label: "Text Matrisi",
    subLabel: "",
    required: false,
    columns:[ 
           ],
       cols: 12,
    rows: [],
   disable: false,
    hint: "",
dynamicRowAddAllow:false,
minRowCount:1,
maxRowCount:5,
    rules: [],
value:{},
    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir
}
export var mailSF = {
    type: "mail",
    cmpName: "VMail",
    icon: "mdi-at",
    label: "E-Posta",
    required: false,
    placeholder: "Yanıtınız",
    counter: 20,
    color: null,
    disable: false,
    hint: "",
    prefix: "",
    suffix: "",
    rules: [rules.email.name],
    identity: false,
    cols: 12,
    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir
}
export var numberSF = {
    type: "number",
    cmpName: "VNumber",
    icon: "mdi-numeric",
    label: "Sayılar",
    required: false,
    placeholder: "Yanıtınız",
    counter: 20,
    color: null,
    disable: false,
    hint: "",
    prefix: "",
    suffix: "",
    rules: [],
    identity: false,
    cols: 12,
    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir
}
export var radioSF = {
    type: "radio",
    cmpName: "VRadio",
    icon: "mdi-radiobox-marked",
    label: "Çoklu Seçenek",
    required: false,

    items: [{ id: "Seçenek-1", name: "Seçenek-1" },
    { id: "Seçenek-2", name: "Seçenek-2" },
    { id: "Seçenek-3", name: "Seçenek-3" }
    ],

    disable: false,
    hint: "",
    columngosterim: false,

    rules: [],
    cols: 12,
    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir

}
export var selectSF = {
    type: "select",
    cmpName: "VSelect",
    icon: "mdi-form-dropdown",
    label: "Efekt Açılır Menü",
    required: false,
    placeholder: "Yanıtınız",
    items: [{ id: "Seçenek-1", name: "Seçenek-1" },
    { id: "Seçenek-2", name: "Seçenek-2" },
    { id: "Seçenek-3", name: "Seçenek-3" }
    ],
    store: [{ id: "Seçenek-1", name: "Seçenek-1" },
    { id: "Seçenek-2", name: "Seçenek-2" },
    { id: "Seçenek-3", name: "Seçenek-3" }],

    disable: false,
    hint: "",
    trigger: false,
    triggerId: "",
    rules: [],
    multi: false,
    cols: 12,
    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir

}
export var dateSF = {
    type: "date",
    cmpName: "VDate",
    icon: "mdi-calendar-range",
    label: "Tarih",
    required: false,


    placeholder: "Yanıtınız",
    disable: false,
    hint: "",

    rules: [],
    cols: 12,
    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir
}
export var dateHtmlSF = {
    type: "dateHtml",
    cmpName: "VDateHtml",
    icon: "mdi-calendar-range",
    label: "Tarih",
    required: false,

dateType:"date",
    placeholder: "Yanıtınız",
    disable: false,
    hint: "",

    rules: [],
    cols: 12,
    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir
}
export var checkSF = {
    type: "check",
    cmpName: "VCheck",
    icon: " mdi-playlist-check",
    label: "Onay Kutuları",
    required: false,
    items: [{ id: "Seçenek-1", name: "Seçenek-1" },
    { id: "Seçenek-2", name: "Seçenek-2" },
    { id: "Seçenek-3", name: "Seçenek-3" }
    ],
   disable: false,
    hint: "",

    rules: [],
    cols: 12,
    incols: 12,
    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir
}
export var checkMatrixSF = {
    type: "checkMatrix",
    cmpName: "VCheckMatrix",
    icon: "mdi-format-list-bulleted-square",
    label: "Onay Kutusu Matrisi",
    required: false,
    columns:[
        // {name:"KESİNLİKLE KATILMIYORUM"},
        //      {name:"KATILMIYORUM"},
        //      {name:"KARARSIZIM"},
        //      {name:"KATILIYORUM"},
        //      {name:"KESİNLİKLE KATILIYORUM"}
            ],
    
    rows: [],
   disable: false,
    hint: "",
cols:12,
    rules: [],

    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir
}
export var radioMatrixSF = {
    type: "radioMatrix",
    cmpName: "VRadioMatrix",
    icon: "mdi-format-list-bulleted",
    label: "Çoklu Seçenek Matrisi",
    required: false,
    columns:[
        // {name:"KESİNLİKLE KATILMIYORUM"},
        //      {name:"KATILMIYORUM"},
        //      {name:"KARARSIZIM"},
        //      {name:"KATILIYORUM"},
        //      {name:"KESİNLİKLE KATILIYORUM"}
            ],
    kolonType:1,
    yildizAdet:1,
    rows: [],
   disable: false,
    hint: "",
cols:12,
    rules: [],

    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir
}
export var fileSF = {
    type: "file",
    cmpName: "VFile",
    icon: "mdi-paperclip",
    label: "Dosya",
    required: false,
    accept: [],
    size: 5,
    multi: false,
    hint: "gdfgdfgdfg",
   disable: false,
    rules: ['filesize'],
    cols: 12,
    incols: 12,
    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir
}

export var htmlSF = {
    type: "html",
    cmpName: "VHtmlEditor",
    icon: "mdi-code-block-tags",
    label: "Html Tasarımı",
       disable: false,
    html: "",
    cols: 12,
    tabanrenk: { istek: false, value: "" },
    borderrenk: { istek: false, value: "" },
    grpName:"",
    visibleIf: {goster:"gizle", logic: "AND", conditions: [ ]} //goster propu goster yada gizle olabilir





}